const API_BASE_URL = 'https://backend.ysskytravel.com/api';

// Fetch all messages from the backend API
export const fetchMessages = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/contact`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const messages = await response.json();
    return messages.map(message => ({
      id: message.id,
      name: message.name,
      email: message.email,
      phone: message.phone,
      subject: message.subject,
      message: message.message,
      read: message.read === 1, // Convert 1/0 to boolean
      createdAt: message.created_at
    }));
  } catch (error) {
    console.error("Error fetching messages:", error);
    throw error;
  }
};

// Delete a message
export const deleteMessage = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/contact/${id}`, {
      method: 'DELETE'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error deleting message:", error);
    throw error;
  }
};

// Mark message as read (sends 1 to backend)
export const markAsRead = async (id) => {
  try {
    const response = await fetch(`https://backend.chinadentalspecialclinic.com/api/contact/${id}/read`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',

      }
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to update read status');
    }

    return data;
  } catch (error) {
    console.error("Mark as read error:", error);
    // You can add user notification here
    throw error;
  }
};